import { Button, Snackbar } from "@mui/material";
import React from 'react'

interface ISnackBarMsgProps {
  message?: string
  open?: boolean
  onClose?: any
  onAction?: any
}

const action = (onaction:any) => (
  <Button className="color-nav-alert" size="small" onClick={onaction}>
    DISMISS
  </Button>
)
export default function SnackBarMsg(props: ISnackBarMsgProps) {
  const { message, open, onClose, onAction } = props

  return (
    <Snackbar
      className="snackbar"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={
        <span id="message-id" color="secondary">
          {message}
        </span>
      }
      action={action(onAction)}
    />
  )
}
